module.exports = __webpack_public_path__ + "media/images/athletes/1761-181afdd0c00f78c531139508d2040255.png";